import { registerResizableHandleElement, registerResizableRootElement } from '@prosekit/web/resizable'

export * from '@prosekit/web/resizable'

export { ResizableHandleElement as ResizableHandle, ResizableRootElement as ResizableRoot } from '@prosekit/web/resizable'

registerResizableRootElement()
registerResizableHandleElement()
